var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { bind } from 'bind-decorator';
import { Colors } from '@lean-body/components/styles';
import { CloseRoundIcon } from '@lean-body/components/atoms/icons/close_round_icon';
import { debounce } from 'lodash-es';
import { Eye } from './icons/eye';
import { RequiredBadge } from './required_badge';
export class Input extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pwShowChecked: false,
            onChangeDebounce: this.props.onChangeDebounce
                ? debounce(this.props.onChangeDebounce, this.props.debounceMs)
                : null,
        };
    }
    render() {
        return (React.createElement("div", { className: css(this.styles.container, this.props.containerClassObject) },
            this.props.label && (React.createElement("div", { className: css(this.styles.label, this.props.labelClassObject) },
                this.props.label,
                this.props.required && React.createElement(RequiredBadge, null))),
            React.createElement("span", { className: css(this.styles.inputContainer) },
                React.createElement("input", { type: this.inputType, value: this.props.value, onChange: this.handleOnChange, onKeyDown: this.props.onKeyDown, disabled: this.props.disabled, className: css(this.styles.input, this.props.hideSpinner && this.styles.spinnerHidden, this.props.hasValidationError && this.styles.validationError, this.props.classObject), placeholder: this.props.placeholder, id: this.props.id, step: this.props.step, name: this.props.name, "data-test": this.props.dataTest, autoFocus: this.props.autoFocus, onFocus: this.props.onFocus, required: this.props.required }),
                this.props.unitLabel && (React.createElement("span", { className: css(this.styles.unitLabel, this.props.unitLabelClassObject) }, this.props.unitLabel)),
                this.props.enablePwVisible && (React.createElement(Eye, { classObject: this.styles.visiblePwWrap, onClick: this.onClickPasswordVisible, close: this.state.pwShowChecked })),
                this.props.validationErrorMessage && (React.createElement("div", { className: css(this.styles.validationErrorMessage) }, this.props.validationErrorMessage))),
            this.props.onClickClearBtn && this.props.value && (React.createElement(CloseRoundIcon, { size: 15, color: Colors.Gray, containerClassObject: [this.styles.closeIconContainer, this.props.closeIconContainerClassObject], onClick: this.props.onClickClearBtn }))));
    }
    onClickPasswordVisible() {
        this.setState({
            pwShowChecked: !this.state.pwShowChecked,
        });
    }
    handleOnChange(event) {
        this.props.onChange(event);
        if (this.state.onChangeDebounce) {
            this.state.onChangeDebounce(event);
        }
    }
    get inputType() {
        if (this.state.pwShowChecked) {
            return 'text';
        }
        return this.props.type;
    }
    get styles() {
        return StyleSheet.create({
            container: {},
            label: {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 14,
                color: Colors.GrayDarkest,
                marginBottom: 8,
            },
            inputContainer: {
                position: 'relative',
            },
            input: {
                backgroundColor: Colors.White,
                border: `1px solid ${Colors.Gray}`,
                '-webkit-appearance': 'none',
                color: Colors.Black,
                cursor: 'pointer',
                height: this.props.height ? this.props.height : 50,
                width: this.props.width ? this.props.width : '100%',
                // fontSize は基本的に統一をしたいので、どうしてもデザイナーと相談の上、props.classObject に fontSize のcssを当ててください
                fontSize: 16,
                letterSpacing: '1px',
                // borderRadius は統一が前提なので、props.borderRadius は作らないでください
                // props.classObject に borderRadius のcssを当ててください
                borderRadius: 4,
                textIndent: '8px',
                paddingRight: this.state.pwShowChecked || this.props.onClickClearBtn ? 32 : 8,
                outline: 'none',
                transition: 'all 0.2s',
                ':focus': {
                    borderColor: Colors.Primary,
                    boxShadow: `0 0 10px -5px ${Colors.Primary}`,
                    cursor: 'text',
                },
                ':disabled': {
                    backgroundColor: '#efefef',
                    cursor: 'default',
                },
                '::placeholder': {
                    color: Colors.GrayDarkest,
                    letterSpacing: 2,
                },
                '::-webkit-input-placeholder': {
                    color: Colors.GrayDarkest,
                    letterSpacing: 2,
                },
                '::-ms-input-placeholder': {
                    color: Colors.GrayDarkest,
                    letterSpacing: 2,
                },
            },
            visiblePwWrap: {
                cursor: 'pointer',
                position: 'absolute',
                right: '14px',
                top: '51%',
                transform: 'translate(0, -50%)',
            },
            unitLabel: {
                position: 'absolute',
                top: 0,
                right: 12,
                color: Colors.GrayDarkest,
            },
            closeIconContainer: {
                position: 'absolute',
                top: 8,
                right: 8,
            },
            spinnerHidden: {
                '::-webkit-inner-spin-button, ::-webkit-outer-spin-button': {
                    margin: 0,
                    '-webkit-appearance': 'none',
                    '-moz-appearance': 'textfield',
                },
            },
            validationError: {
                ':focus': {
                    border: `1px solid ${Colors.Alert}`,
                },
                border: `1px solid ${Colors.Alert}`,
            },
            validationErrorMessage: {
                marginTop: 4,
                color: Colors.Alert,
                fontSize: 12,
                fontWeight: 400,
                lineHeight: '160%',
                letterSpacing: 0.48,
            },
        });
    }
}
__decorate([
    bind
], Input.prototype, "onClickPasswordVisible", null);
__decorate([
    bind
], Input.prototype, "handleOnChange", null);
